export const startConfigs = {
  excludeAssetFilter: (url: string) => url.includes('thoughtworks.innocraft.cloud'), // matomo js and report domain
  sandbox: false,
  prefetch: false
};